import { Component } from '@angular/core';
import { ActivatedRoute} from '@angular/router';


@Component({
  selector: 'app-acknowledgement',
  templateUrl: './acknowledgement.component.html',
  styleUrls: ['./acknowledgement.component.scss'],
  
})
export class AcknowledgementComponent{

  public title: string = 'Crew Self Service - Cash order request';
  public status: string = '';
  public message: string = 'This cash order request has been acknowledged';
  isClosed = false;

  constructor(private readonly route: ActivatedRoute) {

   

    route.params.subscribe(val =>{
      this.status = val['action_type'];
      if(this.status === 'Approved'){
        this.message = 'This cash order request has been acknowledged';
      }else if(this.status === 'Rejected'){
        this.message = 'This cash order request has been rejected';
      }
    });

    route.queryParams.subscribe(val =>{
      if(val['expired']){
        this.status = 'Approved';
        this.message = 'This cash order request has been already processed';
      }
    });
  }


}
